import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import styled from 'styled-components';
import dayjs, { Dayjs } from 'dayjs';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';

const CustomStyleDatePicker = styled(TimePicker)`
  & label {
    color: #888;
  }
  & label.Mui-focused {
    color: #888;
  }
  & .notchedOutline {
    border-color: #888;
  }
  & .MuiOutlinedInput-root {
    color: #333;
    & fieldset {
      border-color: #888;
    }
    &.Mui-focused fieldset {
      border-color: #888;
    }
    &:hover fieldset {
      border-color: #888;
    }
  }
`;

export default function CustomTimePicker({
  label,
  size,
  initValue,
  onChange,
}: { label: string; size?: 'medium' | 'small'; initValue?: string; onChange?: any }) {
  const [val, setVal] = useState<Dayjs>();
  const handleChange = (value: Dayjs) => {
    setVal(value);
    onChange && onChange(value !== null ? value.format('HH:mm') : null);
  };

  useEffect(() => {
    const now = new Date();
    if (initValue) {
      const [hour, min] = initValue.split(':');
      now.setHours(Number(hour), Number(min));
    } else {
      now.setHours(0, 0);
    }
    const dayjsVal = dayjs(now);
    setVal(dayjsVal);
    onChange && onChange(dayjsVal.format('HH:mm'));
  }, [initValue]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CustomStyleDatePicker
        sx={{ svg: { color: '#888' }, width: '11rem' }}
        views={['hours', 'minutes']}
        slotProps={{
          field: { clearable: true },
          textField: { size: size ? size : 'medium', label, slotProps: { inputLabel: { shrink: true } } },
        }}
        onChange={handleChange}
        value={val}
      />
    </LocalizationProvider>
  );
}
